module.exports = __webpack_public_path__ + "static/assets/1d4dfcf66187640c2e9082e7ca8762b7.svg";